import * as React from 'react';

import styles from './gradient-wrapper.module.css';

type Props = {
    children: React.ReactNode;
};

/* Wrapper around a grid to add gradients to the top
and bottom for ~- pIzZazZ -~ */
export function GradientWrapper(props: Props) {
    return <div className={styles['gradient-wrapper']}>{props.children}</div>;
}
